import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Footer from '../components/layout/Footer';

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero Header Banner */}
      <div style={{ backgroundColor: '#0f172a', color: '#ffffff', padding: '32px 24px 48px', position: 'relative' }}>
        <div style={{ maxWidth: '960px', margin: '0 auto 16px auto', display: 'flex', alignItems: 'center' }}>
          <button
            onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              borderRadius: '20px',
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: '#ffffff',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              backdropFilter: 'blur(8px)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.25)')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)')}
          >
            <FiArrowLeft size={18} />
            Back
          </button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '32px', fontWeight: '900', margin: '0 0 12px 0', letterSpacing: '-0.5px' }}>
            Terms & Conditions
          </h1>
          <p style={{ fontSize: '15px', color: '#94a3b8', margin: 0, maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
            Welcome to HoneyCool. Please read these terms carefully before placing orders or using our platform.
          </p>
        </div>
      </div>

      {/* Main Legal Content */}
      <div style={{ maxWidth: '960px', margin: '36px auto', padding: '0 24px', flex: 1, width: '100%', boxSizing: 'border-box' }}>
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '36px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', textAlign: 'left' }}>
          
          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              1. Introduction & Agreement
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              These Terms and Conditions govern your access to and use of the <strong>HoneyCool</strong> website, mobile applications, and B2B/B2C services provided by Honeywill Technologies. By accessing our products, placing orders for HVAC components, refrigeration valves, or copper coils, you agree to be bound by these terms.
            </p>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              2. Orders, Pricing & 18% GST Invoicing
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: '0 0 12px 0' }}>
              All product prices listed on HoneyCool are inclusive of <strong>18% GST</strong> as per Indian Goods & Services Tax regulations. 
            </p>
            <ul style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0, paddingLeft: '20px' }}>
              <li>Orders are subject to stock availability and price confirmation.</li>
              <li>GST compliant Tax Invoices are automatically generated for every completed purchase.</li>
              <li>B2B clients requiring GST credit must provide a valid GSTIN during address checkout.</li>
            </ul>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              3. Shipping, Logistics & Delivery
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              We partner with verified logistics and courier networks across India. Estimated delivery times are provided at checkout. Order tracking statuses (<em>Pending, Confirmed, Shipped, Out for Delivery, Delivered</em>) are updated in real-time in your account dashboard.
            </p>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              4. Product Quality, Warranty & Returns
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              All industrial valves, copper coils, and HVAC components are quality certified. Customers may request returns or replacements within 7 days of delivery for defective or damaged items, provided the original packaging and serial numbers are intact.
            </p>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              5. Customer Product Reviews
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              Only verified buyers who have received a <strong>DELIVERED</strong> order may post product ratings, feedback, and photos. HoneyCool reserves the right to moderate or remove inappropriate content.
            </p>
          </div>

          <div style={{ marginBottom: '0' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              6. Contact & Support
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              If you have any questions regarding our Terms & Conditions, please call our toll-free support line at <strong>1800-3000-2434</strong> or email <strong>support@honeycool.com</strong>.
            </p>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
